<mat-dialog-content>
  <t4-campaign-details [CampagneID]="campaignId" [isDialog]="true"></t4-campaign-details>
</mat-dialog-content>
